import { render, staticRenderFns } from "./gak-sejong.kr.vue?vue&type=template&id=7fb78ec2&"
import script from "./gak-sejong.kr.vue?vue&type=script&lang=js&"
export * from "./gak-sejong.kr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports